<template>
    <div>
        <a-modal
            v-model="show"
            :title="null"
            centered
            @cancel="onCloseAlert()"
            :dialogClass="getDialogClass"
            wrapClassName="ab-site-alert-modal-wrapper"
            :bodyStyle="getStyles"
            :footer="null"
            :mask-closable="false"
        >
            <div
                v-if="alert && alert.data && !alert.data.section_image"
                :style="withoutSectionImage"
            >
                <h3
                    v-if="alert.data.heading"
                    style="margin-bottom: 20px"
                    :style="{ color: alert.data.text_color || '#18587a' }"
                >
                    {{ alert.data.heading }}
                </h3>
                <p
                    v-html="alert.data.content"
                    style="font-size: 1.1em"
                    :style="{ color: alert.data.text_color || '#18587a' }"
                ></p>
                <p
                    v-if="alert.data.button_text"
                    style="
                        margin-top: 32px;
                        text-align: center;
                        padding-left: 90px;
                        padding-right: 90px;
                    "
                >
                    <a-button
                        :type="alert.data.button_type || 'primary'"
                        :size="alert.data.button_size || 'large'"
                        block
                        :shape="alert.data.button_shape || 'round'"
                        @click.prevent="redirectToUrl(alert)"
                    >
                        {{ alert.data.button_text }}
                    </a-button>
                </p>
            </div>
            <div
                class="row row-eq-height"
                v-if="
                    alert &&
                    alert.data &&
                    alert.data.section_image &&
                    alert.data.image_position === 'right'
                "
            >
                <div class="col-md-6 text-center" style="padding: 25px">
                    <h4
                        v-if="alert.data.heading"
                        style="margin-bottom: 15px"
                        :style="{ color: alert.data.text_color || '#18587a' }"
                    >
                        {{ alert.data.heading }}
                    </h4>
                    <p
                        v-html="alert.data.content"
                        style="font-size: 1em"
                        :style="{ color: alert.data.text_color || '#18587a' }"
                    ></p>
                    <p v-if="alert.data.button_text" style="margin-top: 20px">
                        <a-button
                            :type="alert.data.button_type || 'primary'"
                            :size="alert.data.button_size || 'large'"
                            block
                            :shape="alert.data.button_shape || 'round'"
                            @click.prevent="redirectToUrl(alert)"
                        >
                            {{ alert.data.button_text }}
                        </a-button>
                    </p>
                </div>
                <div
                    class="col-md-6"
                    :style="{
                        backgroundImage: `url(${alert.data.section_image})`,
                        backgroundSize: 'cover',
                    }"
                ></div>
            </div>
            <div
                class="row row-eq-height"
                v-if="
                    alert &&
                    alert.data &&
                    alert.data.section_image &&
                    alert.data.image_position === 'left'
                "
            >
                <div
                    class="col-md-6"
                    :style="{
                        backgroundImage: `url(${alert.data.section_image})`,
                        backgroundSize: 'cover',
                    }"
                ></div>
                <div class="col-md-6">
                    <div class="text-center" style="padding: 25px">
                        <h4
                            v-if="alert.data.heading"
                            style="margin-bottom: 15px"
                            :style="{
                                color: alert.data.text_color || '#18587a',
                            }"
                        >
                            {{ alert.data.heading }}
                        </h4>
                        <p
                            v-html="alert.data.content"
                            style="font-size: 1em"
                            :style="{
                                color: alert.data.text_color || '#18587a',
                            }"
                        ></p>
                        <p
                            v-if="alert.data.button_text"
                            style="margin-top: 20px"
                        >
                            <a-button
                                :type="alert.data.button_type || 'primary'"
                                :size="alert.data.button_size || 'large'"
                                block
                                :shape="alert.data.button_shape || 'round'"
                                @click.prevent="redirectToUrl(alert)"
                            >
                                {{ alert.data.button_text }}
                            </a-button>
                        </p>
                    </div>
                </div>
            </div>
            <div
                class="d-flex flex-column"
                v-if="
                    alert &&
                    alert.data &&
                    alert.data.section_image &&
                    alert.data.image_position === 'top'
                "
            >
                <div
                    :style="{
                        width: '100%',
                        height: '220px',
                    }"
                >
                    <img
                        :src="alert.data.section_image"
                        alt="Selection Image"
                        height="220px"
                        width="100%"
                    />
                </div>
                <div style="width: 100%">
                    <div class="text-center" style="padding: 30px 40px">
                        <h4
                            v-if="alert.data.heading"
                            style="margin-bottom: 25px"
                            :style="{
                                color: alert.data.text_color || '#18587a',
                            }"
                        >
                            {{ alert.data.heading }}
                        </h4>
                        <p
                            v-html="alert.data.content"
                            style="font-size: 1em"
                            :style="{
                                color: alert.data.text_color || '#18587a',
                            }"
                        ></p>
                        <p
                            v-if="alert.data.button_text"
                            style="
                                margin-top: 25px;
                                padding-left: 60px;
                                padding-right: 60px;
                            "
                        >
                            <a-button
                                :type="alert.data.button_type || 'primary'"
                                :size="alert.data.button_size || 'large'"
                                block
                                :shape="alert.data.button_shape || 'round'"
                                @click.prevent="redirectToUrl(alert)"
                            >
                                {{ alert.data.button_text }}
                            </a-button>
                        </p>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
    props: ["popupAlerts"],
    data() {
        return {
            show: false,
            alert: null,
            is_preview: false,
        };
    },
    computed: {
        getStyles() {
            const styles = {
                borderRadius: "10px",
            };
            if (this.alert && this.alert.data && this.alert.data.bg_image) {
                styles.backgroundImage = `url(${this.alert.data.bg_image})`;
                styles.backgroundSize = "cover";
            } else {
                styles.backgroundColor =
                    (this.alert &&
                        this.alert.data &&
                        this.alert.data.bg_color) ||
                    "#fff";
            }
            styles.color =
                (this.alert && this.alert.data && this.alert.data.text_color) ||
                "#000";
            return styles;
        },
        withoutSectionImage() {
            const style = {
                textAlign: "center",
                padding: "55px 65px 45px !important",
            };
            return style;
        },
        getDialogClass() {
            let className = "ab-site-alert-modal-small";
            if (
                this.alert &&
                this.alert.data &&
                this.alert.data.section_image &&
                this.alert.data.image_position !== "top"
            ) {
                className = "ab-site-alert-modal-large";
            }
            return className;
        },
    },
    methods: {
        onCloseAlert() {
            this.show = false;
            if (!this.is_preview) {
                Cookies.set(`slidestack_popup_alert_${this.alert.id}`, true, {
                    expires: this.alert.reopen_after || 1,
                });
            }
        },
        redirectToUrl(alert) {
            if (
                alert &&
                alert.data &&
                alert.data.button_link &&
                alert.data.button_link !== ""
            ) {
                window.location.href = alert.data.button_link;
            }
        },
    },
    created() {
        const {
            preview_popup_alert,
            active_popup_alerts,
            user_type: userType,
        } = this.popupAlerts;
        // If admin user & preview banner alert exists, show it
        if (preview_popup_alert && userType === "admin-users") {
            this.alert = preview_popup_alert;
            this.show = true;
            this.is_preview = true;
            return;
        }
        // If admin user & no preview banner alert, then don't show any alert & return
        if (userType === "admin-users") return;
        // If not admin user & preview banner alert exists, show it based on following conditions
        if (
            !preview_popup_alert &&
            active_popup_alerts &&
            active_popup_alerts.length > 0 &&
            userType !== "admin-users"
        ) {
            let alertForAll = null;
            let alertForSpecific = null;
            active_popup_alerts.map(function (alert, index) {
                const hasCookie = Cookies.get(
                    `slidestack_popup_alert_${alert.id}`
                );
                if (alert.alert_for === userType && !hasCookie) {
                    alertForSpecific = alert;
                }
                if (alert.alert_for === "all-users" && !hasCookie) {
                    alertForAll = alert;
                }
            });
            let show = false;
            if (alertForSpecific) {
                show = true;
                this.alert = alertForSpecific;
            } else if (alertForAll && !alertForSpecific) {
                show = true;
                this.alert = alertForAll;
            } else {
                show = false;
            }
            setTimeout(() => {
                this.show = show;
            }, 5000);
        }
    },
};
</script>
